import { createContext, useContext, useEffect, useState } from "react";
import { sanityClient, urlFor } from "../lib/sanityClient";
import { PORTFOLIO_QUERY } from "../lib/queries";
import { normalizePortfolio } from "../lib/normalize";

const PortfolioContext = createContext(null);

const imageUrl = (source, { width }) =>
  urlFor(source).width(width).auto("format").url();

export const PortfolioProvider = ({ children }) => {
  const [state, setState] = useState({ status: "loading" });

  useEffect(() => {
    let cancelled = false;
    sanityClient
      .fetch(PORTFOLIO_QUERY)
      .then((raw) => {
        if (!cancelled) {
          setState({
            status: "ready",
            data: normalizePortfolio(raw, imageUrl),
          });
        }
      })
      .catch((error) => {
        if (!cancelled) setState({ status: "error", error });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (state.status === "loading") {
    return (
      <div role="status" style={messageStyle}>
        loading...
      </div>
    );
  }
  if (state.status === "error") {
    return (
      <div role="alert" style={messageStyle}>
        Could not load portfolio content. Please refresh the page.
      </div>
    );
  }
  return (
    <PortfolioContext.Provider value={state.data}>
      {children}
    </PortfolioContext.Provider>
  );
};

export const usePortfolio = () => {
  const context = useContext(PortfolioContext);
  if (!context) {
    throw new Error("usePortfolio must be used inside <PortfolioProvider>");
  }
  return context;
};

const messageStyle = {
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#607B96",
  fontFamily: "'Fira Code', monospace",
};

export default PortfolioContext;
